import React from 'react';
import Header from './components/Header';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Education from './components/Education';
import Certificates from './components/Certificates';
import Contact from './components/Contact';

const Portfolio = () => {
  const containerStyle = {
    backgroundColor: '#000000',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    fontSize: '14px',
    lineHeight: '1.4',
    margin: 0,
    padding: '15px', // reduced padding for mobile
    paddingBottom: '88px', // clearance for the floating view toggle
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100%', // ensures no overflow
    overflowX: 'auto', // prevents breaking long lines
    textShadow: '0 0 5px rgba(0,255,0,0.5)',
    border: '2px solid #00FF00',
    boxShadow: '0 0 20px rgba(0,255,0,0.3)',
    boxSizing: 'border-box'
  };
  

  const terminalHeaderStyle = {
    backgroundColor: '#001100',
    color: '#00FF00',
    padding: '8px 12px',
    margin: '-15px -15px 15px -15px',
    borderBottom: '1px solid #00FF00',
    fontSize: 'clamp(8px, 2.4vw, 12px)',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    whiteSpace: 'pre',        // keep the ASCII box intact (no broken wrapping)
    overflowX: 'auto'         // scroll horizontally on very narrow screens instead
  };
  

  const sectionStyle = {
    marginBottom: '30px'
  };

  const dividerStyle = {
    border: 'none',
    borderTop: '1px solid #00FF00',
    margin: '25px 0',
    opacity: 0.7,
    boxShadow: '0 1px 0 rgba(0,255,0,0.3)'
  };

  return (
    <div style={containerStyle}>
      <pre style={terminalHeaderStyle}>
        <span>┌─ TERMINAL v2.1.3 ─────────────────────────┐</span><br/>
        <span>│ fauzan@portfolio:~$ cat portfolio.txt     │</span><br/>
        <span>└───────────────────────────────────────────┘</span>
      </pre>
      
      <Header />
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <About />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Skills />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Projects />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Experience />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Education />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Certificates />
      </div>
      <hr style={dividerStyle} />
      
      <div style={sectionStyle}>
        <Contact />
      </div>
      
      <div style={{
        marginTop: '30px',
        padding: '10px',
        backgroundColor: '#001100',
        border: '1px solid #00FF00',
        fontSize: '12px',
        textAlign: 'center'
      }}>
        <span>fauzan@portfolio:~$ _</span>
      </div>
    </div>
  );
};

export default Portfolio;
